import React, { useState } from "react";
import { Button, Checkbox } from "@jugl-web/ui-components";
import { useTranslations } from "@jugl-web/utils";

interface DowngradePlanAlertContentProps {
  targetPlanName: string;
  currentPlanName: string;
  onCancel: () => void;
  onDowngrade: () => void;
}

export const DowngradePlanAlertContent: React.FC<
  DowngradePlanAlertContentProps
> = ({ targetPlanName, currentPlanName, onCancel, onDowngrade }) => {
  const [isConfirmed, setIsConfirmed] = useState(false);
  const { t } = useTranslations();

  return (
    <div className="flex flex-col gap-14">
      <div className="flex flex-col gap-[18px]">
        <div className="flex flex-col gap-[10px]">
          <p className="font-secondary text-dark-700 text-sm leading-[1.5]">
            {t(
              {
                id: "subscription-plans-dialog.downgrade-confirmation-text",
                defaultMessage:
                  "You're about to downgrade to {targetPlan}. {currentPlan} Plan & Add-ons features will not be available anymore",
              },
              {
                targetPlan: (
                  <span className="bg-gradient-to-r from-[#2196F3] to-[#8A41D3] bg-clip-text font-medium text-transparent">
                    {targetPlanName} Plan
                  </span>
                ),
                currentPlan: currentPlanName,
              }
            )}
          </p>
        </div>
        <label className="flex cursor-pointer items-center gap-2">
          <Checkbox
            isChecked={isConfirmed}
            onChange={(e) => setIsConfirmed(e.target.checked)}
            size="sm"
          />
          <span className="font-secondary text-dark-900 text-[13px]">
            {t({
              id: "subscription-plans-dialog.downgrade-confirm-checkbox",
              defaultMessage: "I understand and confirm the action",
            })}
          </span>
        </label>
      </div>

      <div className="flex gap-4">
        <Button
          color="grey"
          className="h-10 w-[140px] shrink-0"
          onClick={onCancel}
        >
          {t({
            id: "common.cancel",
            defaultMessage: "Cancel",
          })}
        </Button>
        <Button
          className="h-10 flex-1"
          style={{
            backgroundColor: "#D75144",
            opacity: isConfirmed ? 1 : 0.4,
            borderColor: "#D75144",
          }}
          isDisabled={!isConfirmed}
          onClick={onDowngrade}
        >
          {t({
            id: "subscription-plans-dialog.downgrade",
            defaultMessage: "Downgrade",
          })}
        </Button>
      </div>
    </div>
  );
};
